import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";

// MangoCubs ships in English only. Keeping i18next as a thin shell so that
// the existing `t('some.key')` calls across the app continue to resolve
// against `en.json`. No language detector, no selector, no resources for
// other languages.
i18n.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

if (typeof document !== "undefined") {
  document.documentElement.lang = "en";
}

export default i18n;
